import Aempty from '@/components/Aempty';
import AformItem from '@/components/AformItem';
import Apages from '@/components/Apages';
import Apopconfirm from '@/components/Apopconfirm';
import './index.css';

export default {
  name: 'Atable',
  props: {
    id: { type: String, default: () => (`a-table-${Math.random().toString().substring(2)}`) },
    rowKey: { type: String, default: () => 'id' },
    flex: { type: Boolean, default: () => false },
    edit: { type: Boolean, default: () => false },
    column: { type: Array | Object, default: () => [] },
    record: { type: Object, default: () => ({ data: [], size: 0 }) },
    data: { type: Array, default: () => null },
    sort: { type: Object | Boolean, default: () => ({ label: '', width: 50 }) },
    selection: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    border: { type: Boolean, default: () => false },
    sortable: { type: Boolean, default: () => false },
    showOverflowTooltip: { type: Boolean, default: () => true },
    global: { type: Boolean, default: () => true },
    pages: { type: Object | Boolean, default: () => ({}) },
  },
  data() {
    return ({
      body: null,
      maxHeight: null,
      height: null,
      active: null,
      item: null,
    });
  },
  watch: {
    loading(status = false) {
      status === false && (this.active = null);
    }
  },
  computed: {
    config() {
      return this.column ? (Array.isArray(this.column) ? this.column : Object.keys(this.column).map((a) => ({ field: a, ...this.column[a] }))) : [];
    },
    relate() {
      const column = [];
      if (this.config && (this.config.length > 0)) {
        this.config.forEach((a, b) => column[b] = this.format(a, b));
        const {
          actionLabel = '操作',
          actionWidth = null,
          viewText = '预览',
          editText = '编辑',
          reviewText = '查看',
          modifyText = '编辑',
          reviseText = '修改',
          reworkText = '更改',
          updateText = '更新',
          censorText = '审查',
          handleText = '审核',
          commitText = '提交',
          removeText = '删除',
          deleteText = '删除',
          exportText = '导出',
          downloadText = '下载',
          action = []
        } = this.$attrs;
        const { view, edit, review, modify, revise, rework, update, handle, censor, commit, remove, download } = this.$listeners;
        if (view || edit || review || modify || revise || rework || update || handle || censor || commit || remove || download || (this.$listeners.delete || this.$listeners.export || (action && (action.length > 0)))) {
          const events = { view, edit, review, modify, revise, rework, update, handle, censor, commit, remove, download, delete: this.$listeners.delete, export: this.$listeners.export };
          const length = ((Object.keys(events).filter((a) => events[a]).length) + action.length);
          column[this.config.length] = (
            <el-table-column
              key="action"
              fixed="right"
              align="center"
              label={actionLabel || '操作'}
              width={actionWidth || ((length > 0) ? (((length > 1) ? (length + 1) : (length + 2)) * 48) : null)}
              formatter={(a, b, c, d) => (
                <div class="a-table-action">
                  {view && (<el-button class="view" key="view" type="text primary" on-click={() => view(a, d, b, c)}>{viewText}</el-button>)}
                  {edit && (<el-button class="edit" key="edit" type="text primary" on-click={() => edit(a, d, b, c)}>{editText}</el-button>)}
                  {review && (<el-button class="review" key="review" type="text primary" on-click={() => review(a, d, b, c)}>{reviewText}</el-button>)}
                  {modify && (<el-button class="modify" key="modify" type="text primary" on-click={() => modify(a, d, b, c)}>{modifyText}</el-button>)}
                  {revise && (<el-button class="revise" key="revise" type="text primary" on-click={() => revise(a, d, b, c)}>{reviseText}</el-button>)}
                  {rework && (<el-button class="rework" key="rework" type="text primary" on-click={() => rework(a, d, b, c)}>{reworkText}</el-button>)}
                  {update && (<el-button class="update" key="update" type="text primary" on-click={() => update(a, d, b, c)}>{updateText}</el-button>)}
                  {censor && (<el-button class="censor" key="censor" type="text warning" on-click={() => censor(a, d, b, c)}>{censorText}</el-button>)}
                  {handle && (<el-button class="handle" key="handle" type="text" on-click={() => handle(a, d, b, c)}>{handleText}</el-button>)}
                  {commit && (<el-button class="commit" key="commit" type="text" on-click={() => commit(a, d, b, c)}>{commitText}</el-button>)}
                  {remove && (<el-button class="remove" key="remove" type="text danger" on-click={() => remove(a, d, b, c)}>{removeText}</el-button>)}
                  {download && (<el-button class="download" key="download" type="text success" on-click={() => download(a, d, b, c)}>{downloadText}</el-button>)}
                  {this.$listeners.export && (<el-button class="export" key="export" type="text success" on-click={() => this.$listeners.export(a, d, b, c)}>{exportText}</el-button>)}
                  {this.$listeners.delete && (
                    <Apopconfirm on-submit={() => this.$listeners.delete(a, d, b, c)}>
                      <el-button class="delete" key="delete" type="text danger">{deleteText}</el-button>
                    </Apopconfirm>
                  )}
                  {action && ((action.length > 0) && (action.map((e, f) => {
                    const label = e.label || e.title || e.text || e.name || e.key || null;
                    if (label) {
                      return (<el-button class={`button-${f}`} key={f} type="text" on-click={g => e.click(a, b, c, d, f, g)} {...e}>{label}</el-button>);
                    }
                  })))}
                </div>
              )}
            />
          );
        }
      }
      return column;
    },
    array() {
      const a = this.record;
      return this.data || a.data || a.list || a.rows || a.page || a.pages || a.source || a.record || a.records || a.dataSource || a.dataSources || [];
    },
    total() {
      const a = this.record;
      return a.total || a.count || a.size || a.sum || a.totality || a.quantity || a.totalCount || a.totalNumber || 0;
    },
    page() {
      const { pageParams = {} } = this.$store.state;
      return ({ ...pageParams, ...this.pages });
    },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        const body = document.getElementById(`${this.id}-body`);
        this.$nextTick(() => {
          body && (this.height = Math.ceil(body.clientHeight));
          this.$nextTick(() => {
            this.resize();
            this.$nextTick(() => this.assign());
          });
        });
      });
    },
    resize(height = 0) {
      this.maxHeight = Math.ceil(this.height - height);
    },
    assign() {
      if (this.$refs.table) {
        this.body = this.$refs.table.bodyWrapper;
        this.$nextTick(() => this.body && (this.body.addEventListener('wheel', this.scroll)));
      }
    },
    scroll(a) {
      if (this.body) {
        if (this.body.scrollHeight > this.body.clientHeight) {
          a.preventDefault();
          this.body.scrollTop += a.deltaY;
        } else {
          if (this.body.scrollWidth > this.body.clientWidth) {
            a.preventDefault();
            this.body.scrollLeft += a.deltaY;
          }
        }
        this.$emit('scroll', a);
      }
    },
    format(a, b) {
      const label = a.header || a.label || a.title || a.text || a.name || '';
      const field = a.dataIndex || a.field || a.index || a.prop || a.name || a.key || '';
      const child = a.childrens || a.children || a.columns || a.column || a.child || a.cols || [];
      const index = field.toLowerCase().trim();
      const width = (index.endsWith('time') || index.endsWith('date')) ? (a.type ? 230 : 170) : null;
      const component = a.components || a.component || a.formatter || a.elements || a.element || a.render || a.dom || null;
      const sorted = (a.sortable || a.sorter) || (this.sortable || this.sorter) || (index.endsWith('time') || index.endsWith('date')) || null;
      const sortable = (field && (component === null)) ? sorted : null;
      const render = (row, column, cellValue, index) => {
        const { size = 'small', editObject = { index: undefined, value: undefined } } = this.$attrs;
        if (a.form || this.edit || (editObject && ((editObject.index !== undefined) && (editObject.index == index)))) {
          const form = editObject.value || row;
          return (<AformItem size={size} form={form} field={field} label={label} class={field} {...{ attrs: { ...a.form } }} />);
        } else {
          return cellValue;
        }
      };
      const formatter = a.form ? render : (component ? ((a, b, c, d) => component(a, d, b, c)) : null);
      const showOverflowTooltip = formatter ? null : this.showOverflowTooltip;
      const attrs = {
        key: b,
        width,
        sortable,
        formatter,
        prop: field,
        scopedSlot: field,
        showOverflowTooltip,
        ...a
      };
      if (a.type && (a.type == 'expand')) {
        const content = a.content || a.context || a.childrens || a.children || a.child || component;
        return (<el-table-column key={b} class-name={field} label={label} {...{ attrs }}>{content}</el-table-column>);
      }
      return (
        <el-table-column key={b} class-name={field} label={label} {...{ attrs }}>
          {child && ((child.length > 0) && (child.map((c, d) => this.format(c, (`${b}-${d}`)))))}
        </el-table-column>
      );
    },
    select(rows = []) {
      const keys = [];
      rows.forEach((a, b) => keys[b] = a[this.rowKey]);
      if (this.global) {
        this.$store.commit('setSelectedKeys', keys);
        this.$store.commit('setSelectedRows', rows);
      }
      this.$emit('select', ({ rows, keys, item: this.item }));
    },
    choose(row, column, event) {
      if (row[this.rowKey] !== undefined) {
        this.active = this.active === row[this.rowKey] ? null : row[this.rowKey];
      }
      this.$emit('click', row, column, event);
      this.$emit('choose', row, column, event);
    },
    change(pages = { page: 1, size: 10 }) {
      if (this.global) {
        this.$store.commit('setPageParams', pages);
        const { pageParams = {}, formParams = {} } = this.$store.state;
        const formatParams = { ...pageParams, ...pages, ...formParams };
        this.$emit('search', formatParams);
        this.$emit('change', formatParams);
      } else {
        this.$emit('search', pages);
        this.$emit('change', pages);
      }
    },
    update(height = 0, delay = 600) {
      let timeout = null;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          this.resize(height);
          clearTimeout(timeout);
          timeout = null;
        }, delay);
      }
    },
    revoke() {
      if (this.body) {
        this.body.removeEventListener('wheel', this.scroll);
        this.$nextTick(() => this.body = null);
      }
      this.maxHeight = null;
      this.height = null;
      this.active = null;
      this.item = null;
    },
  },
  render() {
    const { emptyText, ...attrs } = this.$attrs;
    const { select, ...on } = this.$listeners;
    return (
      <div id={this.id} class={['a-table', (this.flex ? 'flex' : null)]}>
        {(this.config.length > 0) && (
          <div id={`${this.id}-body`} class="a-table-body" v-loading={this.loading}>
            <el-table
              ref="table"
              data={this.array}
              max-height={this.maxHeight}
              stripe={null}
              border={this.border}
              row-class-name={({ row }) => ((row[this.rowKey] !== undefined) && (row[this.rowKey] === this.active)) ? ('a-table-row active') : ('a-table-row')}
              cell-style={{ padding: '0' }}
              header-row-class-name={() => ('a-table-header-row')}
              header-cell-style={{ padding: '0' }}
              header-cell-class-name={() => ('a-table-header-cell')}
              on-select={(_, item) => this.item = item}
              on-select-all={() => this.item = null}
              on-selection-change={this.select}
              row-key={this.rowKey}
              class={this.border ? null : ('no-border')}
              on-row-click={this.choose}
              {...{ attrs }}
              on={on}
            >
              {this.selection && (<el-table-column key="selection" type="selection" width={40} fixed="left" align="center" class-name="selection" />)}
              {(this.sort !== null || this.sort !== false) && (<el-table-column key="sort" type="index" fixed="left" align="center" class-name="sort" attrs={this.sort} />)}
              {this.$slots.before}
              {this.$slots.front}
              {this.$slots.left}
              {this.relate}
              {this.$slots.default}
              <div slot="empty" class="a-table-empty">{!this.loading && (<Aempty description={emptyText} />)}</div>
            </el-table>
          </div>
        )}
        {this.data === null && (this.pages && (
          <div id={`${this.id}-foot`} class="a-table-foot">
            <Apages padding="0" margin="0" disabled={this.loading} pages={this.page} total={parseInt(this.total)} on-change={this.change} />
          </div>
        ))}
      </div>
    );
  }
}